import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ViConfirmDialog {
  title: string;
  content: string;
  cancelBtn?: string;
  confirmBtn: string;
  closeIcon?: boolean;
}

@Component({
  selector: 'vi-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog-component.scss'],
})
export class ViConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ViConfirmDialog,
    public dialogRef: MatDialogRef<ViConfirmDialogComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
